import { IActiveCountry } from 'services/APIService';

// Sort countries alphabetically by display name using a locale- and
// accent-aware comparison. The backend orders countries by a naive byte
// comparison, which misplaces accented names such as "Côte d'Ivoire" (the
// `ô` sorts after every ASCII letter). `localeCompare` with base sensitivity
// treats `ô` as `o`, so "Côte d'Ivoire" is placed between "Costa Rica" and
// "Croatia".
export const sortCountriesByName = (
    countries: IActiveCountry[]
): IActiveCountry[] =>
    [...countries].sort((a, b) =>
        a.name.localeCompare(b.name, 'en', { sensitivity: 'base' })
    );
